module.exports = __webpack_public_path__ + "static/media/sicherung_schema.80f11476.jpg";